import { formatAsCurrency, formatNumeral, checkIfSignificantOtherIsEligible, getNumEligibleChildren, getSelectionStatusVerb, getChildVsChildren, getEligibleMembersDisplayText, getCoveredMembersDisplayText, } from '../helpers/utilities';
import { variableFunctions as globalVariableFunctions } from './global';
export const variableFunctions = {
    // Verb to use in display text about the user's HI plan selection.
    selectionStatusVerbDisplayText: (data) => {
        const { selectionStatus } = data.user.HI;
        return getSelectionStatusVerb(selectionStatus);
    },
    moduleName: (data) => data.user.parabolaModel.storybookModules?.hospital || null,
    recommendedModule: globalVariableFunctions.recommendedModule,
    recommendedModuleDisplayText: globalVariableFunctions.recommendedModuleDisplayText,
    eligibleKidsNum: getEligibleKidsNum,
    hasEligibleSignificantOther: getHasEligibleSignificantOther,
    eligibleChildTerm: (data) => {
        const eligibleKidsNum = getEligibleKidsNum(data);
        return getChildVsChildren(eligibleKidsNum);
    },
    eligibleMembersDisplayText: (data) => {
        const { numKids } = data.user.Global;
        const eligibleKidsNum = getEligibleKidsNum(data);
        const hasEligibleSignificantOther = getHasEligibleSignificantOther(data);
        const { spouseTerm } = globalVariableFunctions;
        return getEligibleMembersDisplayText(numKids, eligibleKidsNum, spouseTerm(data), hasEligibleSignificantOther);
    },
    coveredMembersDisplayText: (data) => {
        const { coverKidsNum, coverSpouse } = data.user.HI;
        const { numKids } = data.user.Global;
        const { spouseTerm } = globalVariableFunctions;
        return getCoveredMembersDisplayText(numKids, coverKidsNum, spouseTerm(data), coverSpouse);
    },
    payoutsLowerMembersDisplayText: (data) => {
        const eligibleKidsNum = getEligibleKidsNum(data);
        const hasEligibleSignificantOther = getHasEligibleSignificantOther(data);
        const { spouseHasSameBenefits, childHasSameBenefits } = data.plan;
        const { spouseTerm, childTerm } = globalVariableFunctions;
        if (hasEligibleSignificantOther && !spouseHasSameBenefits) {
            return eligibleKidsNum && !childHasSameBenefits
                ? 'family'
                : spouseTerm(data);
        }
        return eligibleKidsNum && !childHasSameBenefits ? childTerm(data) : null;
    },
    payoutsLowerCoveredMembersDisplayText: (data) => {
        const { spouseHasSameBenefits, childHasSameBenefits } = data.plan;
        const { numKids } = data.user.Global;
        const { coverKidsNum, coverSpouse } = data.user.HI;
        const { spouseTerm, childTerm } = globalVariableFunctions;
        // User is covering spouse/partner and spouses have lower payouts
        if (coverSpouse && !spouseHasSameBenefits) {
            // User is also covering any kids and kids have lower payouts
            if (coverKidsNum && !childHasSameBenefits) {
                return numKids === coverKidsNum
                    ? 'your family'
                    : `your ${spouseTerm(data)} and ${formatNumeral(coverKidsNum)} of your children`;
            }
            return `your ${spouseTerm(data)}`;
        }
        // User not covering spouse/partner OR spouses do not have lower payouts
        // User covering kid AND children have lower payouts
        if (coverKidsNum && !childHasSameBenefits) {
            return numKids === coverKidsNum
                ? `your ${childTerm(data)}`
                : `${formatNumeral(coverKidsNum)} of your children`;
        }
        return null;
    },
    ICULimitUnitDisplayText: (data) => {
        const { icuMaxUnit, icuMaxNumber } = data.plan;
        if (icuMaxUnit) {
            return icuMaxNumber === 1
                ? icuMaxUnit?.slice(0, icuMaxUnit.length - 1)
                : icuMaxUnit;
        }
        return null;
    },
    guaranteedIssueVerbDisplayText: (data) => {
        return data.plan.hasGuaranteedIssue ? 'will not' : 'may';
    },
    pregnancyCovgVerbDisplayText: (data) => {
        return data.plan.hasPregnancy ? 'are also' : "aren't";
    },
    admissionAmountDisplayText: (data) => {
        return data.plan.hospitalAdmissionAmount
            ? formatAsCurrency(data.plan.hospitalAdmissionAmount)
            : null;
    },
    admissionFrequencyDisplayText: (data) => {
        if (data.plan.hospitalAdmissionMaxNumber) {
            return data.plan.hospitalAdmissionMaxNumber === 1
                ? 'once'
                : `${data.plan.hospitalAdmissionMaxNumber} times`;
        }
        return null;
    },
    confinementAmountDisplayText: (data) => {
        return data.plan.hospitalConfinementAmount
            ? formatAsCurrency(data.plan.hospitalConfinementAmount)
            : null;
    },
    confinementLimitUnitDisplayText: (data) => {
        const { hospitalConfinementMaxUnit, hospitalConfinementMaxNumber } = data.plan;
        if (hospitalConfinementMaxUnit) {
            return hospitalConfinementMaxNumber === 1
                ? hospitalConfinementMaxUnit?.slice(0, hospitalConfinementMaxUnit.length - 1)
                : hospitalConfinementMaxUnit;
        }
        return null;
    },
    ICUAmountDisplayText: (data) => {
        return data.plan.icuAmount ? formatAsCurrency(data.plan.icuAmount) : null;
    },
    carrierName: (data) => data.plan.carrierName || null,
    confinementFrequency: (data) => data.plan.hospitalConfinementMaxNumber || null,
    confinementLimitPeriod: (data) => data.plan.hospitalConfinementMaxWindow || null,
    ICUFrequency: (data) => data.plan.icuMaxNumber || null,
    ICULimitPeriod: (data) => data.plan.icuMaxWindow || null,
    coveredServices: (data) => data.plan.coveredServices || '',
    childAgeLimit: (data) => data.plan.maxAgeChildren || null,
    externalId: (data) => data.plan.externalId || null,
};
function getEligibleKidsNum(data) {
    return getNumEligibleChildren(data.user.Global.numKids, data.user.Global.dependents, data.plan.availableToChildren, data.plan.maxAgeChildren);
}
function getHasEligibleSignificantOther(data) {
    return checkIfSignificantOtherIsEligible(data.user.Global.spouseType, data.plan.availableToSpouse, data.plan.availableToPartner);
}
//# sourceMappingURL=hospitalIndemnity.js.map